module.exports = __webpack_public_path__ + "img/sell.09f4e04.webp";